/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefOrganizationData } from '../../models/api-def-organization-data';
import { ApiDefProjectData } from '../../models/api-def-project-data';

export interface OrganizationsCreateWithProject$Params {
      body: {
'organization'?: ApiDefOrganizationData;
'project'?: ApiDefProjectData;
}
}

export function organizationsCreateWithProject(http: HttpClient, rootUrl: string, params: OrganizationsCreateWithProject$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'organization'?: ApiDefOrganizationData;
'project'?: ApiDefProjectData;
}>> {
  const rb = new RequestBuilder(rootUrl, organizationsCreateWithProject.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'organization'?: ApiDefOrganizationData;
      'project'?: ApiDefProjectData;
      }>;
    })
  );
}

organizationsCreateWithProject.PATH = '/organizations';
